/* eslint jsx-a11y/no-static-element-interactions:off */
/* eslint class-methods-use-this:off */
/* eslint no-console:off */
/* eslint no-class-assign:off */

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import Menu from '../components/menus/Menu';
import Edition from './Edition';

class Header extends Component {
  constructor() {
    super();
    this.dom = {};
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);
  }
  componentDidMount() {
    this.dom.body = document.querySelector('body');
  }
  componentWillReceiveProps(newProps) {
    const { location } = this.props;
    if (newProps.location.pathname !== location.pathname) {
      this.closeMenu();
    }
  }
  closeMenu() {
    this.dom.body.classList.remove('is-mobile-menu-active');
  }
  openMenu() {
    this.dom.body.classList.add('is-mobile-menu-active');
  }
  toggleMenu() {
    if (this.dom.body.classList.contains('is-mobile-menu-active')) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  handleSwipe(event) {
    if (event.deltaX < 0) {
      this.closeMenu();
    }
  }
  render() {
    const style = {
      backgroundColor: this.props.edition.background,
    };
    const { ...rest } = this.props;
    const { edition, lang } = this.props;
    return (
      <div className="header">
        <Link className="home-link" to="/">
          <div className="logo" />
        </Link>
        <div className="scroll-wrapper">
          <div className="header__inner">
            <div className="header__controls">
              <span onClick={this.toggleMenu} className="menu-toggle">
                <span style={style} className="menu-toggle__dash" />
                <span style={style} className="menu-toggle__dash" />
                <span style={style} className="menu-toggle__dash" />
              </span>
              <Edition {...rest} />
            </div>
            <Menu
              handleSwipe={this.handleSwipe}
              edition={edition}
              lang={lang}
            />
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  lang: PropTypes.string.isRequired,
  location: PropTypes.shape({
  }).isRequired,
  edition: PropTypes.shape({
    year: PropTypes.string,
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
  }),
};

Header.defaultProps = {
  edition: {},
};

Header = withRouter(connect()(Header));

export default Header;



// WEBPACK FOOTER //
// ./js/containers/Header.js